const projects = [
    {
        title: "Huddle",
        id: 1,
        img: "images/huddle.jpg",
        link: "https://huddlelandingpage-six.vercel.app/"
    },
    {
        title: "Loopstudios",
        id: 2,
        img: "images/loop.jpg",
        link: "https://loopstudios-indol.vercel.app/"
    },
    {
        title: "Insure LP",
        id: 3,
        img: "images/insure.jpg",
        link: "https://insurelandingpage-delta.vercel.app/"
    },
    {
        title: "React TODO APP",
        id: 4,
        img: "images/todo.png",
        link: "https://justdoit-umber.vercel.app/"
    },
    {
        title: "React Note APP",
        id: 5,
        img: "images/keeper.png",
        link: "https://react-keeper.vercel.app/"
    },
    {
        title: "React Recipe APP",
        id: 6,
        img: "images/recipe.png",
        link: "https://recipesearchapp.vercel.app/"
    }
];

export default projects;